import React, { useState, useEffect, useRef } from "react";
import {
    SiHtml5, SiCss3, SiJavascript, SiReact, SiPhp, SiMysql,
    SiWordpress, SiBootstrap, SiAdobephotoshop, SiAdobeillustrator,
    SiAdobexd, SiAdobepremierepro, SiOdoo
} from 'react-icons/si';
import { Trans, useTranslation } from "react-i18next";


const technos = {
    programming: [
        { name: 'HTML', icon: <SiHtml5 />, percent: 90 },
        { name: 'CSS', icon: <SiCss3 />, percent: 85 },
        { name: 'Bootstrap', icon: <SiBootstrap />, percent: 75 },
        { name: 'JavaScript', icon: <SiJavascript />, percent: 65 },
        { name: 'React', icon: <SiReact />, percent: 65 },
        { name: 'WordPress', icon: <SiWordpress />, percent: 75 },
        { name: 'Odoo (Python & XML)', icon: <SiOdoo />, percent: 60 },
        { name: 'SQL', icon: <SiMysql />, percent: 50 },
        { name: 'PHP', icon: <SiPhp />, percent: 30 },



    ],
    design: [
        { name: 'Photoshop', icon: <SiAdobephotoshop />, percent: 80 },
        { name: 'Illustrator', icon: <SiAdobeillustrator />, percent: 70 },
        { name: 'Adobe XD', icon: <SiAdobexd />, percent: 85 },
        { name: 'Premiere Pro', icon: <SiAdobepremierepro />, percent: 50 },

    ]
};

const Stats = () => {
    const { t, i18n } = useTranslation();
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="techno-section ">
            <h3 className="sousTitre">{t("competences.title")}</h3>
            <div className="stats-container" ref={ref}>

{Object.keys(technos).map(categoryKey => (
    <div key={categoryKey} className="category">
        <h4 className="category-title pt-4">
            {t(`competences.categories.${categoryKey}`)}
        </h4>

        {technos[categoryKey].map((tech, i) => (
            <div key={i} className="tech">
                <div className="tech-info">
                    <span className="tech-icon">{tech.icon}</span>
                    <span className="tech-name">{tech.name}</span>
                    <span className="tech-percent">{tech.percent}%</span>
                </div>

                <div className="progress-background">
                    <div
                        className="progress-bar"
                        style={{ width: visible ? `${tech.percent}%` : "0%" }}
                    />
                </div>
            </div>
        ))}
    </div>
))}
            </div>
        </div>
    );
};

export default Stats;
